import React, { useContext, useEffect, useState } from 'react'
import { CircularProgress, Dialog, DialogContent, DialogTitle, Typography, makeStyles } from '@material-ui/core'
import MROButton from 'components/buttons'
import { CommercialServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/commercial'
import { ToastMessageContext } from 'lib/contexts/message_context'



const useStyles = makeStyles((theme) => ({
    dialog: {
        "& .MuiDialog-paperWidthMd": {
            boxShadow: "0px 3px 6px #00000029",
            // position: "absolute",
            // left: "calc(50% - 250px)",
            width: '650px',
            height: '240px',
            borderRadius: '5px'
        }
    },
    dialogTitle: {
        color: theme.palette.primary.main,
        fontSize: '18px',
        textAlign: 'center'
    }

}))


export default function ApproveAll(props) {
    const classes = useStyles()
    const { currentSelectedOrder, handleClose, getList, getActionIndicators } = props
    const [loading, setLoading] = useState(false)
    const message = useContext(ToastMessageContext)

    const handleSubmit = async () => {


        setLoading(true)
        const formData = new FormData()
        formData.append("workshop_order_id", currentSelectedOrder?.id)
        await CommercialServices.updateApprovalActionStatus(formData).then((res) => {
            handleClose()
            getList()
            getActionIndicators()
            message.showToastMessage({
                message: "All Action Approved Successfully !",
                variant: "success",
            });
        }).catch(() => {
            handleClose()
            getList()
            getActionIndicators()
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {
            setLoading(false)
        })
    }



    return (
        <div> <Dialog
            // fullWidth={true}
            maxWidth={'md'}
            open={true}
            onClose={handleClose}
            className={classes.dialog}
            aria-labelledby="dispatch-files">

            <DialogTitle ><Typography variant='subtitle2' className={classes.dialogTitle}> Approve ALL Unapproved Actions </Typography> </DialogTitle>
            <DialogContent>

                <Typography style={{ textAlign: 'center' }}>This action will approve all actions that are currently unapproved!</Typography>
                <br />

                <Typography style={{ textAlign: 'center' }}>Are you sure you want to continue?</Typography>
                <br />
                <div style={{ textAlign: 'center', marginTop: '10px' }}>
                    <MROButton
                        //   disabled={loading}
                        type="button"
                        variant={"contained"}
                        onClick={handleClose}
                    >
                        Cancel
                    </MROButton>
                    <MROButton

                        style={{ marginLeft: '14px' }}
                        loading={loading}

                        variant={"contained"}
                        color="primary"
                        onClick={handleSubmit}
                    >
                        Yes
                    </MROButton>
                </div>
            </DialogContent>

        </Dialog>
        </div >
    )
}
